import React, { useState, useEffect } from "react";
import "../Styles/Livejob.css";
import { TiArrowBack } from "react-icons/ti";
import { useNavigate, useLocation } from "react-router-dom";
import ApiService from "../nhrc_apis/ApiService";

const { JobAPI, UploadAPI } = ApiService;

const LiveJobpost = () => {

  const navigate = useNavigate();
  const location = useLocation();

  const editJob = location.state?.editJob;

  const [showPreview, setShowPreview] = useState(false);

  const [skillInput, setSkillInput] = useState("");

  const [perkInput, setPerkInput] = useState("");

  const [loading, setLoading] = useState(false);

  const [formData, setFormData] = useState({

    companyname: "",

    jobTitle: "",

    department: "",

    workMode: "",

    roles: "",

    qualification: "",

    requiredSkills: "",

    skills: [],

    experienceMin: "",

    experienceMax: "",

    jobLocation: "",

    jobLocality: "",

    openings: "",

    salaryMin: "",

    salaryMax: "",

    whtspnumber: "",

    deadline: "",

    attachment: null,

    perks: [],

    perksDisplay: "",
  });

  /* =========================================
     EDIT MODE LOAD
  ========================================= */

  useEffect(() => {

    if (editJob) {

      setFormData({

        companyname:
          editJob.company_name || "",

        jobTitle:
          editJob.title || "",

        department:
          editJob.department || "",

        workMode:
          editJob.work_mode || "",

        roles:
          editJob.roles_responsibilities || "",

        qualification:
          editJob.qualification_required || "",

        requiredSkills:
          editJob.required_skills || "",

        skills:
          editJob.required_skills
            ? editJob.required_skills
                .split(",")
                .map((s) => s.trim())
            : [],

        experienceMin:
          editJob.min_experience || "",

        experienceMax:
          editJob.max_experience || "",

        jobLocation:
          editJob.location || "",

        jobLocality:
          editJob.locality || "",

        openings:
          editJob.openings || "",

        salaryMin:
          editJob.min_salary || "",

        salaryMax:
          editJob.max_salary || "",

        whtspnumber:
          editJob.whatsapp_number || "",

        deadline:
          editJob.application_deadline || "",

        attachment:
          editJob.attachment || "",

        perks:
          editJob.perks_benefits
            ? editJob.perks_benefits
                .split(",")
                .map((p) => p.trim())
            : [],

        perksDisplay:
          editJob.perks_benefits || "",
      });
    }

  }, [editJob]);

  /* =========================================
     SKILLS
  ========================================= */

  const skillsList = [

    "Python",

    "Java",

    "React.js",

    "Node.js",

    "SQL",

    "HTML",

    "CSS",

    "JavaScript",

    "AWS",

    "Problem Solving",

    "Communication",
  ];

  const allSkills = [

    ...new Set([
      ...skillsList,
      ...formData.skills,
    ]),
  ];

  const handleSkillKeyDown = (e) => {

    if (e.key === "Enter") {

      e.preventDefault();

      const value =
        skillInput.trim();

      if (!value) return;

      if (
        !formData.skills.includes(
          value
        )
      ) {

        const updated = [
          ...formData.skills,
          value,
        ];

        setFormData((prev) => ({

          ...prev,

          skills: updated,

          requiredSkills:
            updated.join(", "),
        }));
      }

      setSkillInput("");
    }
  };

  const handleSkillSelect = (skill) => {

    const updated =
      formData.skills.includes(
        skill
      )

        ? formData.skills.filter(
            (s) => s !== skill
          )

        : [
            ...formData.skills,
            skill,
          ];

    setFormData((prev) => ({

      ...prev,

      skills: updated,

      requiredSkills:
        updated.join(", "),
    }));
  };

  /* =========================================
     PERKS
  ========================================= */

  const defaultPerks = [

    "PF/ESI",

    "Health Insurance",

    "Paid Leave",

    "Food",

    "Bonus",

    "Incentives",

    "Two-way Cab",
  ];

  const allPerks = [

    ...new Set([
      ...defaultPerks,
      ...formData.perks,
    ]),
  ];

  const handlePerkSelect = (perk) => {

    const updated =
      formData.perks.includes(
        perk
      )

        ? formData.perks.filter(
            (p) => p !== perk
          )

        : [
            ...formData.perks,
            perk,
          ];

    setFormData((prev) => ({

      ...prev,

      perks: updated,

      perksDisplay:
        updated.join(", "),
    }));
  };

  const handlePerkKeyDown = (e) => {

    if (e.key === "Enter") {

      e.preventDefault();

      const value =
        perkInput.trim();

      if (!value) return;

      if (
        !formData.perks.includes(
          value
        )
      ) {

        const updated = [
          ...formData.perks,
          value,
        ];

        setFormData((prev) => ({

          ...prev,

          perks: updated,

          perksDisplay:
            updated.join(", "),
        }));
      }

      setPerkInput("");
    }
  };

  /* =========================================
     INPUT HANDLER
  ========================================= */

  const handleChange = (e) => {

    const {
      name,
      value,
      type,
      files,
    } = e.target;

    if (type === "file") {

      const file = files[0];

      if (!file) return;

      setFormData((prev) => ({

        ...prev,

        attachment: file,
      }));

    } else {

      setFormData((prev) => ({

        ...prev,

        [name]: value,
      }));
    }
  };

  /* =========================================
     SUBMIT
  ========================================= */

  const handleSubmit = async () => {

    try {

      setLoading(true);

      let uploadedFileUrl =
        formData.attachment;

      /* =====================================
         FILE UPLOAD
      ===================================== */

      if (
        formData.attachment &&
        formData.attachment instanceof File
      ) {

        const uploadFormData =
          new FormData();

        uploadFormData.append(
          "file",
          formData.attachment
        );

        uploadFormData.append(
          "membership_id",
          "1"
        );

        uploadFormData.append(
          "file_type",
          "job_attachment"
        );

        const uploadResponse =
          await UploadAPI.uploadFile(
            uploadFormData
          );

        console.log(
          "UPLOAD RESPONSE",
          uploadResponse.data
        );

        uploadedFileUrl =

          uploadResponse.data?.file_url ||

          uploadResponse.data?.url ||

          uploadResponse.data?.path ||

          uploadResponse.data?.file ||

          "";
      }

      /* =====================================
         FINAL PAYLOAD
      ===================================== */

      const payload = {

        title:
          formData.jobTitle,

        company_name:
          formData.companyname,

        department:
          formData.department,

        work_mode:
          formData.workMode,

        roles_responsibilities:
          formData.roles,

        qualification_required:
          formData.qualification,

        required_skills:
          formData.requiredSkills,

        min_experience:
          Number(
            formData.experienceMin
          ) || 0,

        max_experience:
          Number(
            formData.experienceMax
          ) || 0,

        location:
          formData.jobLocation,

        locality:
          formData.jobLocality,

        openings:
          Number(
            formData.openings
          ) || 0,

        min_salary:
          Number(
            formData.salaryMin
          ) || 0,

        max_salary:
          Number(
            formData.salaryMax
          ) || 0,

        whatsapp_number:
          formData.whtspnumber,

        application_deadline:
          formData.deadline,

        perks_benefits:
          formData.perksDisplay,

        attachment:
          uploadedFileUrl,
      };

      console.log(
        "FINAL PAYLOAD",
        payload
      );

      /* =====================================
         UPDATE JOB
      ===================================== */

      if (
        editJob?.id ||
        editJob?.job_id
      ) {

        const jobId =
          editJob.id ||
          editJob.job_id;

        const response =
          await JobAPI.updateJob(
            jobId,
            payload
          );

        console.log(
          "UPDATE RESPONSE",
          response.data
        );

        alert(
          "Job Updated Successfully"
        );

      }

      /* =====================================
         CREATE JOB
      ===================================== */

      else {

        const response =
          await JobAPI.createJob(
            payload
          );

        console.log(
          "CREATE RESPONSE",
          response.data
        );

        alert(
          "Job Posted Successfully"
        );
      }

      navigate(
        "/dashboard/AdminjobList"
      );

    } catch (error) {

      console.log(
        "JOB SUBMIT ERROR",
        error
      );

      console.log(
        "ERROR RESPONSE",
        error?.response?.data
      );

      alert(

        typeof error?.response?.data?.detail === "string"

          ? error?.response?.data?.detail

          : error?.response?.data?.message ||

            "Failed To Submit Job"
      );

    } finally {

      setLoading(false);
    }
  };

  /* =========================================
     PREVIEW URL
  ========================================= */

  const previewUrl =

    formData.attachment instanceof File

      ? URL.createObjectURL(
          formData.attachment
        )

      : formData.attachment;

  /* =========================================
     UI
  ========================================= */

  return (

    <div className="hrjobpost-wrapper">

      <div className="hrjobpost-card">

        <button
          className="jobback"
          onClick={() => navigate(-1)}
        >
          <TiArrowBack /> Back
        </button>

        <h2 className="hrjobpost-title">
          JOB POSTING
        </h2>

        <div
          className="hrjobpost-grid"
          style={{
            alignItems: "flex-start",
          }}
        >

          <div className="hrjobpost-field">
            <label>Job Title*</label>

            <input
              name="jobTitle"
              value={formData.jobTitle}
              onChange={handleChange}
            />
          </div>

          <div className="hrjobpost-field">
            <label>Company Name*</label>

            <input
              name="companyname"
              value={formData.companyname}
              onChange={handleChange}
            />
          </div>

          <div className="hrjobpost-field">
            <label>Department*</label>

            <select
              name="department"
              value={formData.department}
              onChange={handleChange}
            >
              <option value="">
                Select
              </option>

              <option value="IT">
                IT
              </option>

              <option value="Non-IT">
                Non-IT
              </option>
            </select>
          </div>

          <div className="hrjobpost-field">
            <label>Work Mode*</label>

            <select
              name="workMode"
              value={formData.workMode}
              onChange={handleChange}
            >
              <option value="">
                Select
              </option>

              <option value="Hybrid">
                Hybrid
              </option>

              <option value="Remote">
                Remote
              </option>

              <option value="Onsite">
                Onsite
              </option>
            </select>
          </div>

          <div className="hrjobpost-field hrjobpost">
            <label>
              Roles & Responsibilities*
            </label>

            <textarea
              name="roles"
              value={formData.roles}
              onChange={handleChange}
            />
          </div>

          <div className="hrjobpost-field">

            <label>Experience*</label>

            <div className="hrjobpost-row">

              <select
                name="experienceMin"
                value={
                  formData.experienceMin
                }
                onChange={handleChange}
              >
                <option value="">
                  Min
                </option>

                <option value="0">
                  0
                </option>

                <option value="1">
                  1
                </option>

                <option value="2">
                  2
                </option>
              </select>

              <select
                name="experienceMax"
                value={
                  formData.experienceMax
                }
                onChange={handleChange}
              >
                <option value="">
                  Max
                </option>

                <option value="3">
                  3
                </option>

                <option value="5">
                  5
                </option>

                <option value="6">
                  6
                </option>
              </select>
            </div>
          </div>

          <div className="hrjobpost-field hrjobpost-full">

            <label>
              Required Skills*
            </label>

            <input
              type="text"
              placeholder="Type a skill and press Enter"
              value={skillInput}
              onChange={(e) =>
                setSkillInput(
                  e.target.value
                )
              }
              onKeyDown={
                handleSkillKeyDown
              }
              className="hrjobpost-skill-input mb-2"
            />

            <textarea
              className="form-control bg-white"
              rows="2"
              value={
                formData.requiredSkills
              }
              readOnly
            />

            <div className="mt-2 d-flex flex-wrap gap-2">

              {allSkills.map(
                (skill, i) => (

                  <span
                    key={i}
                    onClick={() =>
                      handleSkillSelect(
                        skill
                      )
                    }
                    className={`badge px-3 py-2 ${
                      formData.skills.includes(
                        skill
                      )
                        ? "bg-primary text-white"
                        : "border border-secondary text-secondary bg-transparent"
                    }`}
                    style={{
                      cursor: "pointer",
                    }}
                  >
                    {skill}
                  </span>
                )
              )}
            </div>
          </div>

          <div className="hrjobpost-field">

            <label>
              Qualification*
            </label>

            <input
              name="qualification"
              value={
                formData.qualification
              }
              onChange={handleChange}
            />
          </div>

          <div className="hrjobpost-field">

            <label>
              Salary Range (LPA)*
            </label>

            <div className="hrjobpost-row">

              <select
                name="salaryMin"
                value={
                  formData.salaryMin
                }
                onChange={handleChange}
              >
                <option value="">
                  Min
                </option>

                <option value="1">
                  1
                </option>

                <option value="2">
                  2
                </option>
              </select>

              <select
                name="salaryMax"
                value={
                  formData.salaryMax
                }
                onChange={handleChange}
              >
                <option value="">
                  Max
                </option>

                <option value="3">
                  3
                </option>

                <option value="5">
                  5
                </option>
              </select>
            </div>
          </div>

          <div className="hrjobpost-field hrjobpost-full">

            <label>
              Perks & Benefits*
            </label>

            <input
              type="text"
              placeholder="Type a perk and press Enter"
              value={perkInput}
              onChange={(e) =>
                setPerkInput(
                  e.target.value
                )
              }
              onKeyDown={
                handlePerkKeyDown
              }
              className="hrjobpost-skill-input mb-2"
            />

            <textarea
              className="form-control bg-white"
              rows="2"
              value={
                formData.perksDisplay
              }
              readOnly
            />

            <div className="hrjobpost-chipbox mt-2 d-flex flex-wrap gap-2">

              {allPerks.map(
                (perk, i) => (

                  <span
                    key={i}
                    onClick={() =>
                      handlePerkSelect(
                        perk
                      )
                    }
                    className={`hrjobpost-chip ${
                      formData.perks.includes(
                        perk
                      )
                        ? "active"
                        : ""
                    }`}
                    style={{
                      cursor: "pointer",
                    }}
                  >
                    {perk}
                  </span>
                )
              )}
            </div>
          </div>

          <div className="hrjobpost-field">

            <label>
              Job Location*
            </label>

            <input
              name="jobLocation"
              value={
                formData.jobLocation
              }
              onChange={handleChange}
            />
          </div>

          <div className="hrjobpost-field">

            <label>
              Job Locality*
            </label>

            <input
              name="jobLocality"
              value={
                formData.jobLocality
              }
              onChange={handleChange}
            />
          </div>

          <div className="hrjobpost-field">

            <label>
              Number of Openings*
            </label>

            <input
              name="openings"
              value={
                formData.openings
              }
              onChange={handleChange}
            />
          </div>

          <div className="hrjobpost-field">

            <label>
              Application Deadline*
            </label>

            <input
              type="date"
              name="deadline"
              value={
                formData.deadline
              }
              onChange={handleChange}
            />
          </div>

          <div className="hrjobpost-field">

            <label>
              Whatsapp Number
            </label>

            <input
              type="tel"
              name="whtspnumber"
              value={
                formData.whtspnumber
              }
              onChange={handleChange}
              maxLength={10}
            />
          </div>

          <div className="hrjobpost-field">

            <label>
              Upload Logo / Attachment*
            </label>

            <input
              type="file"
              name="attachment"
              onChange={handleChange}
            />

            {formData.attachment && (

              <button
                type="button"
                onClick={() =>
                  setShowPreview(
                    true
                  )
                }
                style={{
                  marginTop: "6px",
                  background:
                    "transparent",
                  border: "none",
                  color: "#0d6efd",
                  cursor: "pointer",
                  fontSize: "13px",
                  padding: 0,
                }}
              >
                View Uploaded Logo / Document
              </button>
            )}
          </div>
        </div>

        <div className="hrjobpost-btn">

          <button
            onClick={handleSubmit}
            disabled={loading}
          >
            {loading
              ? "Submitting..."
              : editJob
              ? "Update Job"
              : "Post Job"}
          </button>
        </div>
      </div>

      {/* =========================================
          PREVIEW MODAL
      ========================================= */}

      {showPreview &&
        formData.attachment && (

        <div
          onClick={() =>
            setShowPreview(false)
          }
          style={{
            position: "fixed",
            inset: 0,
            background:
              "rgba(0,0,0,0.6)",
            display: "flex",
            alignItems: "center",
            justifyContent:
              "center",
            zIndex: 9999,
          }}
        >

          <div
            onClick={(e) =>
              e.stopPropagation()
            }
            style={{
              background: "#fff",
              padding: "20px",
              borderRadius: "8px",
              maxWidth: "90%",
              maxHeight: "90%",
            }}
          >

            {previewUrl &&
            (
              previewUrl.includes(".png") ||
              previewUrl.includes(".jpg") ||
              previewUrl.includes(".jpeg") ||
              previewUrl.includes(".webp")
            ) ? (

              <img
                src={previewUrl}
                alt="Preview"
                style={{
                  maxWidth: "700px",
                  maxHeight: "400px",
                  width: "100%",
                  objectFit:
                    "contain",
                  display: "block",
                  margin: "0 auto",
                }}
              />

            ) : (

              <iframe
                src={previewUrl}
                title="Document Preview"
                style={{
                  width: "60vw",
                  height: "60vh",
                  border: "none",
                }}
              />
            )}

            <div
              style={{
                textAlign: "right",
                marginTop: "12px",
              }}
            >

              <button
                onClick={() =>
                  setShowPreview(
                    false
                  )
                }
                style={{
                  padding:
                    "6px 14px",
                  border: "none",
                  background:
                    "#dc3545",
                  color: "#fff",
                  borderRadius: "4px",
                  cursor: "pointer",
                }}
              >
                Close
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default LiveJobpost;